const ENV = import.meta.env.VITE_ENV_TPE;

const URLS = {
  execute_api: '',
  get_status: '',
  update_species_data_model: '',
  get_species_data_model: '',
  get_bucket_data_versions: '',
  delete_model_prediction_genus: '',
  restore_to_prev_version: '',
};

if (ENV === 'develop') {
  URLS.execute_api = 'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/develop/trigger';
  URLS.get_status = 'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/develop/get_endpoint_status';
  URLS.update_species_data_model =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/develop/updateDataModelContentFromS3';
  URLS.get_species_data_model =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/Stage/get_data_model_list_from_s3';
  URLS.get_bucket_data_versions =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/Stage/get_bucket_version_data';
  URLS.delete_model_prediction_genus =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/Stage/delete_model_prediction_genus';
  URLS.restore_to_prev_version =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/Stage/restore_to_prev_version';
} else if (ENV === 'production') {
  URLS.execute_api = 'https://n9748ggsz1.execute-api.eu-north-1.amazonaws.com/prod/trigger';
  URLS.get_status = 'https://n9748ggsz1.execute-api.eu-north-1.amazonaws.com/prod/get_endpoint_status';
  URLS.update_species_data_model =
    'https://n9748ggsz1.execute-api.eu-north-1.amazonaws.com/prod/updateDataModelContentFromS3';
  URLS.get_species_data_model =
    'https://n9748ggsz1.execute-api.eu-north-1.amazonaws.com/prod/get_data_model_list_from_s3';

  URLS.get_bucket_data_versions =
    'https://n9748ggsz1.execute-api.eu-north-1.amazonaws.com/prod/get_bucket_version_data';
  URLS.delete_model_prediction_genus =
    'https://n9748ggsz1.execute-api.eu-north-1.amazonaws.com/prod/delete_model_prediction_genus';
  URLS.restore_to_prev_version = 'https://n9748ggsz1.execute-api.eu-north-1.amazonaws.com/prod/restore_to_prev_version';
} else {
  // Default to development URLs
  URLS.execute_api = 'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/develop/trigger';
  URLS.get_status = 'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/develop/get_endpoint_status';
  URLS.update_species_data_model =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/develop/updateDataModelContentFromS3';
  URLS.get_species_data_model =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/develop/get_data_model_list_from_s3';
  URLS.get_bucket_data_versions =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/Stage/get_bucket_version_data';
  URLS.delete_model_prediction_genus =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/Stage/delete_model_prediction_genus';
  URLS.restore_to_prev_version =
    'https://6eiydw3zmk.execute-api.eu-north-1.amazonaws.com/Stage/restore_to_prev_version';
}

export { URLS };
